export default __webpack_public_path__ + "static/media/about-shadow.d6de993c.png";